import { withInstall } from '../utils/index';
import Model from './index.vue';
import './index.less';

export const TlbsModel = withInstall(Model);
export default TlbsModel;
